import type { WalletWriteProgressPhase } from '../wallet/walletSigningFlow'
import type { Web3Library } from '../wallet/walletContext'
import { isWalletSigningLockActive } from '../wallet/walletSigningLock'
import { recoverMobileLiquiditySessionHash } from './recoverMobileLiquiditySessionHash'
import { isMobileLiquidityWalletWaitActive, readMobileLiquiditySession } from './mobileLiquiditySession'

export type LiquidityWalletReturnReconcileResult = 'idle' | 'recovered-hash'

export async function reconcileLiquidityWalletReturn(input: {
  library?: Web3Library | null
  account?: string | null
  chainId?: number | null
  attemptingTxn: boolean
  walletProgressPhase: WalletWriteProgressPhase | null
  hasPromiseInFlight: boolean
}): Promise<LiquidityWalletReturnReconcileResult> {
  if (input.hasPromiseInFlight) return 'idle'

  const session = readMobileLiquiditySession()
  const signingLocked = isWalletSigningLockActive()
  const walletWait = isMobileLiquidityWalletWaitActive(session)

  if (!walletWait && !signingLocked) return 'idle'
  if (!input.attemptingTxn && input.walletProgressPhase !== 'wallet' && !signingLocked) return 'idle'

  if (!input.library || !input.account || !input.chainId) return 'idle'

  const recovered = await recoverMobileLiquiditySessionHash(input.library, input.account, input.chainId)
  if (recovered?.hash) return 'recovered-hash'

  const afterRecovery = readMobileLiquiditySession()
  if (afterRecovery?.hash) return 'recovered-hash'

  return 'idle'
}
